import { FontWeight, Text } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as InverseSmallLogo } from '@Assets/logos/lili-inverse-small.svg';
import { ReactComponent as EnvelopeIcon } from '@Assets/icons/envelope.svg';
import { LILI_SUPPORT_EMAIL, LILI_SUPPORT_PHONE } from '@Types/consts';
import { ReactComponent as PhoneIcon } from '@Assets/icons/phone.svg';

interface EmbeddedSupportDetailsProps {
  shouldCenter?: boolean;
  mb?: string;
}
export const EmbeddedSupportDetails = ({
  shouldCenter = false,
  mb = '88px',
}: EmbeddedSupportDetailsProps) => {
  const { t } = useTranslation();
  return (
    <div className={twMerge(`flex flex-col gap-[12px] mb-[${mb}]`, shouldCenter && 'items-center')}>
      <InverseSmallLogo />
      <div className={twMerge('flex flex-col gap-[4px]', shouldCenter && 'items-center')}>
        <Text.H12 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-primary-inverse'>
          {t('passwordlessSideMenu.customerService')}
        </Text.H12>
        <div className='flex gap-[16px]'>
          <div className={twMerge('flex gap-[4px]', shouldCenter && 'items-center')}>
            <EnvelopeIcon />
            <Text.H12 className='text-text-main-primary-inverse'>
              <a
                href={`mailto:${LILI_SUPPORT_EMAIL}`}
                target='_blank'
                className='text-text-brand-primary-inverse hover:text-text-brand-primary-inverse-hover underline'
                rel='noreferrer'>
                {LILI_SUPPORT_EMAIL}
              </a>
            </Text.H12>
          </div>
          <div className={twMerge('flex gap-[4px]', shouldCenter && 'items-center')}>
            <PhoneIcon />
            <Text.H12 className='text-text-main-primary-inverse'>{LILI_SUPPORT_PHONE}</Text.H12>
          </div>
        </div>
        <Text.H12 className='text-text-main-primary-inverse'>
          {t('pages.underReview.supportHours')}
        </Text.H12>
      </div>
    </div>
  );
};
